export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export const getUrlOfFile = (file, default_image= 'avatars/default.jpeg') => {
  try {
    return URL.createObjectURL(file);	 
  } catch (error) {
    return file || './img/' + default_image;	
  }
}


export const getClassStatus = (status) => {
  let result = 'success';
  switch(status){
    case"active":
      result="success";
    break;
    case"publish":
      result="success";
    break;
    case"inactive":
      result="danger";
    break;
    case"draft":
      result="danger";
    break;
    case"deactive":
      result="danger";
    break;
  }
  return result;
}

export const str_slug = (string) => {
  var slug = "";
  // Change to lower case
  var titleLower = string.toLowerCase();
  // Letter "e"
  slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
  // Letter "d"
  slug = slug.replace(/đ/gi, 'd');
  // Trim the last whitespace
  slug = slug.replace(/\s*$/g, '');
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, '-');
  
  return slug;
}

export const camel_case = (string) => {
  if(string){
      return string.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index)
              {
                  return word.toUpperCase();
              });
  }
}

export const check_ext = (url) => {
  let result = null;
  if(/\.(mp3|mp4|3gp)$/i.test(url)){
    result = 'audio'
  }
  return result;
}

export const get_ext = (url) => {
  const pieces = url.split(".");
  return pieces[pieces.length - 1];
}

export const is_video = (url) => {
  let result = false;
  if(/\.(mp4|3gp)$/i.test(url)){
    result = true;
  }
  return result;
}